import { RecommendedPlanState } from "src/utils/redux/slices/recommendedPlan";
import { ServerContextState } from "src/utils/redux/slices/serverContext";
import { showChooseTrialPage } from "src/utils/userSegment/features";

export function getTrialInfo(
  recommendedPlan: RecommendedPlanState,
  serverContext: ServerContextState
) {
  const showChooseTrial = showChooseTrialPage();

  const trialFeeEligible = !serverContext.trial_fee_waived;
  const trialFeeExists = !!recommendedPlan.trial_fee;
  const planHasTrial = recommendedPlan.has_trial;
  return {
    hasTrial: showChooseTrial || planHasTrial,
    trackingData: {
      showChooseTrial,
      trialFeeEligible,
      trialFeeExists,
      planHasTrial,
    },
  };
}
